module.exports = __webpack_public_path__ + "img/1566900810.ad5ae1f3.jpg";